// Flag global "partie en cours" : permet a des composants globaux (ex. LoginBadge)
// de reagir sans etre couples a la logique de jeu.

let inProgress = false;
const listeners = new Set();

export function setGameInProgress(v) {
  const next = !!v;
  if (next === inProgress) return;
  inProgress = next;
  for (const l of listeners) { try { l(inProgress); } catch { /* noop */ } }
}

export function subscribeGameState(l) {
  listeners.add(l);
  l(inProgress);
  return () => listeners.delete(l);
}

export function isGameInProgress() {
  return inProgress;
}
